import * as React from "react";
import { NavLink, withRouter } from "react-router-dom";
import { Site, Nav, Button, RouterContextProvider, AccountDropdown } from "tabler-react";
import { ERevolutionsBrand, ERevolutionsFooterNote } from "./ERevolutionsBrand.react";
import { getTokenStatus } from "./api";

const navBarItems = [
  { value: "Dashboard", to: "/", icon: "home", LinkComponent: withRouter(NavLink), useExact: true },
  { value: "Strategy Fleet", to: "/fleet", icon: "layers", LinkComponent: withRouter(NavLink) },
  { value: "Trades", to: "/trades", icon: "list", LinkComponent: withRouter(NavLink) },
  { value: "Shadow Report", to: "/shadow-report", icon: "bar-chart", LinkComponent: withRouter(NavLink) },
  { value: "Market", to: "/market", icon: "activity", LinkComponent: withRouter(NavLink) },
  { value: "Decisions", to: "/decisions", icon: "git-branch", LinkComponent: withRouter(NavLink) },
  { value: "Logs", to: "/logs", icon: "file-text", LinkComponent: withRouter(NavLink) },
];

class TradesSiteWrapper extends React.Component {
  state = {
    kiteLoginUrl: "",
    logsMenu: false,
    canUpdateToken: false,
    tokenBlock: "Save your Kite API key on Account before you connect Zerodha.",
  };

  componentDidMount() {
    this.loadKiteLoginUrl();
  }

  loadKiteLoginUrl = async () => {
    try {
      const token = await getTokenStatus();
      const url = token && token.login_url ? String(token.login_url).trim() : "";
      const canUpdate = Boolean(token && token.can_update_token);
      this.setState({
        kiteLoginUrl: canUpdate && url ? url : this.state.kiteLoginUrl,
        logsMenu: Boolean(token && token.logs_menu),
        canUpdateToken: canUpdate,
        tokenBlock: canUpdate
          ? ""
          : String((token && token.live_token_detail) || this.state.tokenBlock),
      });
    } catch (e) {
      this.setState({ canUpdateToken: false });
    }
  };

  render() {
    const { children } = this.props;
    const { kiteLoginUrl, logsMenu, canUpdateToken, tokenBlock } = this.state;
    const navItems = logsMenu ? navBarItems : navBarItems.filter((item) => item.to !== "/logs");
    const tokenHref = kiteLoginUrl || "/login";
    const year = new Date().getFullYear();
    const accountOptions = [
      { icon: "user", value: "Account", to: "/account" },
      { icon: "message-square", value: "Need help", to: "/custom-request" },
    ];
    if (canUpdateToken) {
      accountOptions.push({ icon: "refresh-cw", value: "Update token", to: tokenHref });
    }
    accountOptions.push({ isDivider: true }, { icon: "log-out", value: "Sign out", to: "/logout" });

    return (
      <Site.Wrapper
        headerProps={{
          href: "/",
          alt: "eRevolutions India",
          children: (
            <React.Fragment>
              <ERevolutionsBrand />
              <div className="d-flex order-lg-2 ml-auto align-items-center">
                <Nav.Item type="div" className="d-none d-md-flex mr-3">
                  {canUpdateToken ? (
                    <Button href={tokenHref} outline size="sm" RootComponent="a" color="primary">
                      Update token
                    </Button>
                  ) : (
                    <Button outline size="sm" color="primary" disabled title={tokenBlock}>
                      Update token
                    </Button>
                  )}
                </Nav.Item>
                <AccountDropdown
                  name="Account"
                  description="Trades Algo"
                  options={accountOptions}
                />
              </div>
            </React.Fragment>
          ),
        }}
        navProps={{ itemsObjects: navItems, withSearchForm: false }}
        routerContextComponentType={withRouter(RouterContextProvider)}
        footerProps={{
          note: <ERevolutionsFooterNote />,
          copyright: (
            <React.Fragment>
              © {year}{" "}
              <a href="https://www.erevolutionsindia.com/" target="_blank" rel="noopener noreferrer">
                eRevolutions India
              </a>
              {" · "}Trades Algo
            </React.Fragment>
          ),
        }}
      >
        {children}
      </Site.Wrapper>
    );
  }
}

export default TradesSiteWrapper;
